export default __webpack_public_path__ + "static/media/s.5b6fdfca.jpg";